// libraries
import React from 'react'

// components
import clsx from 'clsx'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// props
export interface Props {
    quote: string
    name?: string
    className?: string
}

export default function MacroQuote({ quote, name, className }: Props) {
    return (
        <div className={clsx('macro-quote', className)}>


            {isNonWhitespaceString(quote) && (
                <blockquote className='macro-quote rich-text'>
                    <span className='macro-quote__content'>
                        <span className='macro-quote__line' aria-hidden='true'></span>
                        <p dangerouslySetInnerHTML={{ __html: quote }} suppressHydrationWarning />
                    </span>
                    {isNonWhitespaceString(name) && (
                        <cite className='macro-quote__name' dangerouslySetInnerHTML={{ __html: name }} suppressHydrationWarning />
                    )}
                </blockquote>
            )}
        </div>
    );
}
